'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('i', {});

var GoogleLoginOrSignup = _react2['default'].createClass({
    displayName: 'GoogleLoginOrSignup',


    propTypes: {
        'openIdUrl': _react2['default'].PropTypes.string.isRequired,
        'isLogIn': _react2['default'].PropTypes.bool,
        'isOptedIn': _react2['default'].PropTypes.bool
    },

    onClickHandler: function onClickHandler() {
        var url = this.props.openIdUrl + '&optIn=' + (this.props.isOptedIn ? '1' : '0');
        var w = window.open(url, '_blank', 'width=640, height=480');
        window.hsGoogleOpenIdWindow = w;
    },

    render: function render() {
        var classSet = (0, _classnames2['default'])({
            'm-google-button': true,
            'm-button': true
        });
        return _jsx('a', {
            className: classSet,
            onClick: this.onClickHandler
        }, void 0, _ref, this.props.isLogIn ? 'Sign in with Google' : 'Sign up with Google');
    }
});

module.exports = GoogleLoginOrSignup;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/google-login-or-signup.jsx
 ** module id = 750
 ** module chunks = 0
 **/